<template>
  <interview-layout>
    <div>
      <div class="d-flex flex-column flex-lg-row justify-content-center">
        <div class="container-narrow w-100">
          <h1
            class="px-4 fade-in-up-enter-active animation-slowest max-100 text-primary"
          >
            Aanvullende subsidies
          </h1>
          <div
            class="fade-in-up-enter-active animation-slowest delay-400"
            inner-class="small"
            color="alternate"
            :outer-padding="true"
          >
            <base-card inner-class="container-narrow w-100" color="alternate" :outer-padding="true">
              <base-card class="mb-4" inner-class="small" color="secondary">
                <h6 class="mb-2">
                  Mogelijke extra subsidie{{
                    possibleSubsidies.length === 1 ? "" : "s"
                  }}
                </h6>
                <div class="mb-3 text-muted">
                  Voor deze aanvullende subsidie{{
                    possibleSubsidies.length === 1 ? "" : "s"
                  }}
                  kunt u mogelijk ook nog in aanmerking komen. Hieronder ziet u
                  welke regelingen dat zijn.
                </div>

                <checkmark-item
                  v-for="subsidy in possibleSubsidies"
                  :key="subsidy"
                  class="mb-2"
                  icon="info-circle-fill"
                >
                  <strong class="fw-600">{{ subsidy }}</strong>
                </checkmark-item>
              </base-card>

              <base-input
                type="radiobuttons"
                :options="yesNo"
                name="interestedInOtherSubsidies"
                v-model:value="lead.otherSubsidies.interestedInOtherSubsidies"
              >
                Wilt u zien voor welke van deze aanvullende subsidies u in aanmerking
                komt?
              </base-input>
            </base-card>
          </div>
        </div>
      </div>

      <button-row class="mt-4 flex-row-reverse">
        <base-button
          class="ms-auto"
          icon="bi-arrow-right"
          type="submit"
          @click="onSubmit"
        >
          Volgende
        </base-button>

        <base-button
          variant="minimal-secondary"
          icon="bi-arrow-left"
          icon-position="start"
          @click="onPrev"
        >
          Terug
        </base-button>
      </button-row>
    </div>
  </interview-layout>
</template>

<script>
import InterviewLayout from "@/views/layouts/InterviewLayout.vue";
import BaseCard from "@/components/BaseCard.vue";
// import BaseForm from "@/components/BaseForm.vue";
import BaseButton from "@/components/BaseButton.vue";
import BaseInput from "@/components/BaseInput.vue";
import ButtonRow from "@/components/ButtonRow.vue";
import CheckmarkItem from "@/components/CheckmarkItem.vue";
import { CommonComposable } from "@/helpers/CommonComposable";
import { useAllStores } from "@/helpers/UseAllStores";
import { FlowService } from "@/services/FlowService";
import { MunicipalitySubsidyService } from "@/services/MunicipalitySubsidyService";

export default {
  components: {
    InterviewLayout,
    BaseCard,
    // BaseForm,
    BaseButton,
    BaseInput,
    ButtonRow,
    CheckmarkItem,
  },
  setup(props, context) {
    const stores = useAllStores();

    return { ...CommonComposable(props, context), ...stores };
  },

  data() {
    return {
      yesNo: [
        {
          label: "Ja",
          value: true,
        },
        {
          label: "Nee",
          value: false,
        },
      ],
    };
  },

  computed: {
    possibleSubsidies() {
      if (!this.lead || !this.lead.address) return [];
      return MunicipalitySubsidyService.getEligibleSubsidies(
        this.lead,
        "financing",
      );
    },
  },

  methods: {
    onSubmit() {
      FlowService.pushNext(this);
    },
    onPrev() {
      FlowService.pushPrev(this);
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss"></style>
